import { render } from "./WebConfig.vue?vue&type=template&id=3ae64798"
import script from "./WebConfig.vue?vue&type=script&lang=js"
export * from "./WebConfig.vue?vue&type=script&lang=js"

import "./WebConfig.vue?vue&type=style&index=0&id=3ae64798&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__